/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Data attribute pass-through for host apps
 *
 * Lets the host tag rendered elements (in-app guides, analytics, tests) with stable
 * `data-*` attributes. Only `data-*` keys are forwarded, so arbitrary props never reach the DOM.
 *
 * @file dataAttributes.js
 */

import PropTypes from 'prop-types';

const isDataAttribute = ([key, value]) => (
  key.startsWith('data-') && value !== undefined && value !== null && value !== ''
);

/**
 * Keeps only the non-empty `data-*` entries of an object
 *
 * @param {Object} attributes e.g. { 'data-componentid': 'AET_ADD_ASSIGNMENT_BUTTON' }
 * @returns {Object} attributes safe to spread onto a DOM element
 */
export const getDataAttributes = (attributes) => (
  Object.fromEntries(Object.entries(attributes || {}).filter(isDataAttribute))
);

export const dataAttributesPropType = PropTypes.objectOf(
  PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool])
);
